import {Injectable} from '@angular/core';
import {L10nLocale, L10nLocaleResolver} from 'angular-l10n';

@Injectable({providedIn: 'root'})
export class UserLanguageResolver implements L10nLocaleResolver {

    constructor() {
    }

    public get(): Promise<L10nLocale | null> {
        // TODO: maybe check user if user language is set in userDetails and prefer this (has to be null on register, first set after language picker updated, picker has to be in user settings)
        // let browserLanguage: L10nLocale | undefined = undefined;
        // if (navigator !== undefined && navigator.language) {
        //     const fullLang = navigator.language;
        //     const shortLang = navigator.language.split('-')[0];
        //
        //     for (const schema of this.config.schema) {
        //         if (schema.locale.language == fullLang || schema.locale.language == shortLang) {
        //             browserLanguage = schema.locale;
        //             break;
        //         }
        //     }
        // }
        // if (browserLanguage === undefined)
        //     browserLanguage = this.config.defaultLocale;
        //
        //
        // // this.translationService.setLocale(browserLanguage!).then();
        // return Promise.resolve(browserLanguage!);
        return Promise.resolve(null);
    }

}